namespace Portico.Directives {

	import Inject = Portico.Decorators.Inject;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

    export interface ITcScriptController {
        key: string;

		dataGroups: pms.DataGroup[];
		dataRows: pms.DataRow[];
		dataTable: pms.DataTable;
		editRow: pms.DataRow;
		tcParent: ITcHtmlController; // is this necessary, or will implementing the angular IController give us this?  doubtful.

		compile: () => void;
    }

	@Inject('$compile', '$element', '$scope', 'dataService', 'dataRowService', 'modalService', 'porticoService', 'serverConstants')
    export class TcScriptController implements ITcScriptController {
        key: string;

		dataGroups: pms.DataGroup[];
		dataRows: pms.DataRow[];
		dataTable: pms.DataTable;
		editRow: pms.DataRow;
		tcParent: TcHtmlController;

		constructor(
			public $compile: angular.ICompileService,
			public $element: angular.IAugmentedJQuery,
			public $scope: angular.IScope,
			public dataService: ps.IDataService,
			public dataRowService: ps.IDataRowService,
			public modalService: ps.IModalService,
			public porticoService: ps.IPorticoService,
			public serverConstants: pmi.IServerConstants
		) {
			this.dataGroups = [];
			this.dataRows = [];
		}

		cancel(index: number) {
			this.modalService.hide('inline-editor');
		}

		compile() {
			let tcCurrent: TcHtmlController | TcScriptController = this;
			let fullKey = this.key;

			this.dataRows = [];

			// should reverse loop to go from absolute to relative key, with short circuiting
			while (tcCurrent) {
				let temp = this.dataService.getDataRows('Script', fullKey);

				if (temp) {
					this.dataRows = this.dataRows.concat(temp);
				}

				tcCurrent = <TcHtmlController>tcCurrent.tcParent;

				if (tcCurrent) {
					fullKey = tcCurrent.key + '.' + fullKey;
				}
			}

			if (this.dataRows.length === 0) {
				this.dataRows.push(null);
			}

			for (let i = 0; i < this.dataRows.length; i++) {
				const dataRow = this.dataRows[i];

				if (dataRow) {
					const portalDataGroups = this.dataService.setup.portal.portalDataGroups.filter((portalDataGroup) => {
						return portalDataGroup.dataGroupId === dataRow.dataGroupId;
					});

					this.dataGroups[i] = portalDataGroups && portalDataGroups.length > 0 ? portalDataGroups[0].dataGroup : null;
				} else {
					const portalDataGroups = this.dataService.setup.portal.portalDataGroups.filter((portalDataGroup) => {
						return portalDataGroup.dataGroup.isPrivate === true;
					});

					this.dataGroups[i] = portalDataGroups && portalDataGroups.length > 0 ? portalDataGroups[0].dataGroup : null;
				}
			}

			const dataColumn = this.dataTable.getDataColumn('Code');
			let fullHtml = '';

			for (let i = this.dataRows.length - 1; i >= 0; i--) {
				const dataRow = this.dataRows[i];
				const dataValue = dataRow ? dataRow.getDataValue(dataColumn.id) : null;
				let code = dataValue ? dataValue.value : null;

				let html = this.getHtml(code);

				if (this.serverConstants.connectTo !== 'Prod') {
					html = this.getEditHtml(i, html, fullKey);
				}

				fullHtml += html;
			}

			this.$element.html(fullHtml);
			this.$compile(this.$element.contents() as any)(this.$scope);
		}

		diff() {
			try {
				(<any>angular.element('#_root_porticoService_dataService_temp_editRow_key-monaco').scope()).$monaco.diff(this.porticoService.dataService.temp.conflict.key);
			} catch {
				// ignore
			}

			this.porticoService.dataService.temp.conflict.dataValues.forEach((dv) => {
				try {
					(<any>angular.element('#_root_porticoService_dataService_temp_editRow_getDataValue_' + dv.dataColumnId + '_value-monaco').scope()).$monaco.diff(dv.value);
				} catch {
					// ignore
				}
			});
		}

		edit(index: number) {
			if (this.dataRows[index]) {
				this.editRow = new pms.DataRow(this.dataRows[index]);
			} else { // ???
				this.editRow = this.dataRowService.create(this.dataTable);
				this.editRow.key = this.key;
			}

			const portalDataGroups = this.dataService.setup.portal.portalDataGroups.filter((portalDataGroup) => {
				return portalDataGroup.dataGroup.isPrivate === true;
			});

			const dataGroup = portalDataGroups && portalDataGroups.length > 0 ? portalDataGroups[0].dataGroup : null;

			if (this.editRow.dataGroupId !== dataGroup.id) {
				this.editRow.id = null;
				this.editRow.dataGroupId = dataGroup.id;

				this.editRow.dataValues.forEach((dataValue) => {
					dataValue.id = null;
					dataValue.dataRowId = null;
				});
			}

			this.dataService.temp.conflict = null;
			this.dataService.temp.diff = () => { this.diff(); };
			this.dataService.temp.dataTable = this.dataTable;
			this.dataService.temp.editRow = this.editRow;
			this.dataService.temp.resolved = false;
			this.dataService.temp.save = () => { this.save(); };

			this.modalService.show('inline-editor');

			try {
				(<any>angular.element('#_root_porticoService_dataService_temp_editRow_key-monaco').scope()).$monaco.edit();
			} catch {
				// ignore
			}

			this.editRow.dataValues.forEach((dv) => {
				try {
					(<any>angular.element('#_root_porticoService_dataService_temp_editRow_getDataValue_' + dv.dataColumnId + '_value-monaco').scope()).$monaco.edit();
				} catch {
					// ignore
				}
			});
		}

		save() {
			this.dataRowService.save(this.editRow).then((dataRow: pms.DataRow) => {
				const portalDataGroups = this.dataService.setup.portal.portalDataGroups.filter((pdg) => {
					return pdg.dataGroupId === dataRow.dataGroupId;
				});

				portalDataGroups[0].dataGroup.dataRows = portalDataGroups[0].dataGroup.dataRows.filter((dr) => {
					return dr.id !== dataRow.id;
				});

				portalDataGroups[0].dataGroup.dataRows.push(dataRow);

				this.modalService.hide('inline-editor');
				this.porticoService.refresh(this.key);
			});
		}

		getHtml(code: string): string {
			let html = '';

			if (code) {
				html = `<script>${code}</script>`;
			}

			return html;
		}

		getDebugHtml(index: number, html: string, key: string): string {
			html =
				`[tc-script key="${key}"]
				<br/>
				<tc-mode-debug>
					${html}
				</tc-mode-debug>`;

			return html;
		}

		getEditHtml(index: number, html: string, key: string): string {
			let clazz = '';

			if (!this.dataGroups[index].isPrivate) {
				clazz += ' text-danger';
			} else {
				clazz += ' text-warning';
			}

			html =
				`<tc-mode-edit ng-if="$app.porticoService.dataService.local.mode === 'edit'">
					<a class="mode-edit-icon" href="" ng-click="$script.edit(${index})" data-html="true" data-toggle="tooltip" data-placement="bottom" data-title="${this.dataGroups[index].name}<br/>Script<br/>${key}"><span class="fa-stack fa-lg"><i class="fa fa-square fa-stack-2x ${clazz}"></i><i class="fa fa-pencil fa-stack-1x fa-inverse"></i></span></a>
					${html}
				</tc-mode-edit>
				<tc-mode-normal ng-if="$app.porticoService.dataService.local.mode !== 'edit'">${html}</tc-mode-normal>`

			return html;
		}
    }

	angular.module('app').directive('tcScript', ['dataService', (dataService: ps.IDataService) => {
		return {
			bindToController: {
				key: '@'
			},
			controller: <any>TcScriptController,
			controllerAs: '$script',
			link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
				const tcScript: TcScriptController = $ctrl[0];

				tcScript.dataTable = dataService.getDataTable('Script');
				tcScript.tcParent = $ctrl[1];

				tcScript.compile();

				$scope.$on(`tc-refresh-${tcScript.key}`, () => {
					tcScript.compile();
				});
			},
			restrict: 'E',
			require: ['tcScript'],
			scope: true
		};
    }]);
}